import { Link } from 'react-router-dom';

export default function CGV() {
    return (
        <div className="legal-page">
            <div className="legal-inner">
                <h1>Conditions G&eacute;n&eacute;rales de Vente</h1>
                <p className="legal-updated">Derni&egrave;re mise &agrave; jour : octobre 2026</p>

                <h2>1. Objet</h2>
                <p>
                    Les pr&eacute;sentes CGV r&eacute;gissent la vente d&rsquo;abonnements sur le site
                    monquiz.fr, &eacute;dit&eacute; par Fabien Nicolet (EI, SIREN 749 975 116).
                </p>

                <h2>2. Services propos&eacute;s</h2>
                <p>
                    monquiz.fr propose des QCM de pr&eacute;paration aux concours et examens professionnels.
                    L&rsquo;acc&egrave;s complet au contenu d&rsquo;une th&eacute;matique n&eacute;cessite
                    la souscription d&rsquo;un abonnement. Un sujet de d&eacute;monstration gratuit est
                    disponible par th&eacute;matique apr&egrave;s cr&eacute;ation de compte.
                </p>

                <h2>3. Tarifs</h2>
                <p>
                    Les abonnements sont propos&eacute;s par th&eacute;matique. <strong>Les tarifs varient
                    selon la th&eacute;matique choisie</strong> et sont affich&eacute;s sur la page
                    d&rsquo;abonnement correspondante avant toute confirmation d&rsquo;achat.
                </p>
                <p>
                    &Agrave; titre indicatif, les abonnements sont g&eacute;n&eacute;ralement propos&eacute;s
                    selon trois dur&eacute;es : 1&nbsp;mois, 6&nbsp;mois et 12&nbsp;mois. Le tarif exact
                    applicable &agrave; chaque th&eacute;matique est indiqu&eacute; en euros TTC sur la page
                    de souscription au moment de l&rsquo;achat.
                </p>
                <p>
                    L&rsquo;&eacute;diteur se r&eacute;serve le droit de modifier les tarifs &agrave; tout
                    moment. Les tarifs applicables sont ceux en vigueur au moment de la souscription et
                    affich&eacute;s explicitement avant la validation du paiement.
                </p>

                <h2>4. Paiement</h2>
                <p>
                    Le paiement est effectu&eacute; par carte bancaire via la plateforme s&eacute;curis&eacute;e
                    Stripe. Aucune donn&eacute;e bancaire n&rsquo;est stock&eacute;e sur nos serveurs.
                    L&rsquo;abonnement est activ&eacute; d&egrave;s confirmation du paiement.
                </p>

                <h2>5. Dur&eacute;e et acc&egrave;s</h2>
                <p>
                    L&rsquo;abonnement donne acc&egrave;s &agrave; l&rsquo;int&eacute;gralit&eacute; du
                    contenu de la th&eacute;matique choisie pour la dur&eacute;e souscrite. &Agrave;
                    l&rsquo;expiration, l&rsquo;acc&egrave;s est automatiquement d&eacute;sactiv&eacute;.
                    L&rsquo;historique et la progression restent consultables.
                </p>
                <p>
                    Afin de garantir une &eacute;quit&eacute; ind&eacute;pendante du mois de souscription,
                    les dur&eacute;es d&rsquo;abonnement sont calcul&eacute;es en jours fixes&nbsp;:
                    1&nbsp;mois&nbsp;=&nbsp;31&nbsp;jours, 6&nbsp;mois&nbsp;=&nbsp;186&nbsp;jours,
                    12&nbsp;mois&nbsp;=&nbsp;372&nbsp;jours.
                </p>
                <p>
                    En cas de renouvellement anticip&eacute; (avant l&rsquo;expiration de l&rsquo;abonnement
                    en cours), la nouvelle p&eacute;riode d&rsquo;acc&egrave;s commence &agrave; l&rsquo;issue
                    de l&rsquo;abonnement existant. Les jours restants ne sont pas perdus.
                </p>
                <p>
                    Un rappel par email est envoy&eacute; avant l&rsquo;expiration de l&rsquo;abonnement.
                    Les abonnements ne sont pas reconduits automatiquement.
                </p>

                <h2>6. Droit de r&eacute;tractation</h2>
                <p>
                    Conform&eacute;ment &agrave; l&rsquo;article L221-28 du Code de la consommation, le
                    droit de r&eacute;tractation ne peut &ecirc;tre exerc&eacute; pour les contenus
                    num&eacute;riques fournis imm&eacute;diatement apr&egrave;s l&rsquo;achat, ce que
                    l&rsquo;utilisateur accepte express&eacute;ment lors de la souscription.
                </p>
                <p>
                    Toutefois, si vous n&rsquo;avez pas encore commenc&eacute; &agrave; utiliser le
                    contenu, vous pouvez demander un remboursement dans les 14 jours suivant l&rsquo;achat
                    en contactant <a href="mailto:contact@monquiz.fr">contact@monquiz.fr</a>.
                </p>

                <h2>7. Service &laquo;&nbsp;Ma Th&eacute;matique&nbsp;&raquo; &mdash; G&eacute;n&eacute;ration de QCM par IA</h2>

                <h3>7.1 Description du service</h3>
                <p>
                    Le service &laquo;&nbsp;Ma Th&eacute;matique&nbsp;&raquo; permet &agrave; l&rsquo;utilisateur
                    d&rsquo;importer un document de son choix (PDF, DOCX, TXT, CSV, HTML ou image) afin de g&eacute;n&eacute;rer automatiquement
                    des questions QCM &agrave; l&rsquo;aide de l&rsquo;intelligence artificielle. Ces questions
                    sont destin&eacute;es &agrave; l&rsquo;entra&icirc;nement personnel de l&rsquo;utilisateur
                    sur la plateforme monquiz.fr. Le document import&eacute; et les instructions associ&eacute;es
                    sont transmis &agrave; notre prestataire d&rsquo;IA &agrave; seule fin de g&eacute;n&eacute;rer
                    les questions&nbsp;; ce traitement est d&eacute;crit dans notre{' '}
                    <a href="/confidentialite">Politique de confidentialit&eacute;</a>.
                </p>

                <h3>7.2 Responsabilit&eacute; du contenu import&eacute;</h3>
                <p>
                    L&rsquo;utilisateur garantit qu&rsquo;il dispose des droits n&eacute;cessaires sur les
                    documents qu&rsquo;il importe, ou que ceux-ci sont libres de droits, ou qu&rsquo;il
                    les utilise dans le cadre d&rsquo;un usage priv&eacute; autoris&eacute; par la loi.
                    L&rsquo;&eacute;diteur ne saurait &ecirc;tre tenu responsable du contenu des documents
                    import&eacute;s par les utilisateurs.
                </p>

                <h3>7.3 Qualit&eacute; des contenus g&eacute;n&eacute;r&eacute;s</h3>
                <p>
                    Les questions g&eacute;n&eacute;r&eacute;es par intelligence artificielle le sont &agrave;
                    titre p&eacute;dagogique et sans garantie d&rsquo;exactitude. L&rsquo;&eacute;diteur ne
                    garantit pas que les questions, r&eacute;ponses et explications produites soient exemptes
                    d&rsquo;erreurs. L&rsquo;utilisateur est invit&eacute; &agrave; v&eacute;rifier les contenus
                    g&eacute;n&eacute;r&eacute;s.
                </p>
                <p>
                    Chaque lot de questions g&eacute;n&eacute;r&eacute;es est relu automatiquement par un second
                    mod&egrave;le d&rsquo;intelligence artificielle, qui &eacute;carte les questions qu&rsquo;il
                    juge erron&eacute;es ou ambigu&euml;s. Cette relecture automatique ne constitue pas une
                    validation humaine et ne garantit pas l&rsquo;absence d&rsquo;erreurs ou d&rsquo;approximations.
                    Les th&eacute;matiques &eacute;ditoriales de monquiz.fr font l&rsquo;objet d&rsquo;une relecture
                    distincte (relecture crois&eacute;e par plusieurs IA et validation humaine) qui ne s&rsquo;applique
                    pas aux th&eacute;matiques personnalis&eacute;es.
                </p>

                <h3>7.4 Licence sur les contenus g&eacute;n&eacute;r&eacute;s</h3>
                <p>
                    En utilisant le service &laquo;&nbsp;Ma Th&eacute;matique&nbsp;&raquo;, l&rsquo;utilisateur
                    accorde &agrave; monquiz.fr une <strong>licence non exclusive, gratuite, mondiale et
                    cessible</strong> pour utiliser, reproduire, adapter et int&eacute;grer les contenus
                    g&eacute;n&eacute;r&eacute;s (questions, r&eacute;ponses, explications) dans son catalogue
                    de questions, y compris &agrave; destination d&rsquo;autres utilisateurs de la plateforme.
                </p>
                <p>
                    Cette licence est accord&eacute;e pour la dur&eacute;e des droits de propri&eacute;t&eacute;
                    intellectuelle applicables. L&rsquo;utilisateur conserve le droit d&rsquo;utiliser les
                    contenus g&eacute;n&eacute;r&eacute;s pour son usage personnel.
                </p>

                <h3>7.5 Suppression des contenus</h3>
                <p>
                    L&rsquo;utilisateur peut &agrave; tout moment supprimer ses sujets personnalis&eacute;s
                    et les questions associ&eacute;es depuis son espace. Les contenus d&eacute;j&agrave;
                    int&eacute;gr&eacute;s au catalogue &eacute;ditorial de monquiz.fr (apr&egrave;s
                    v&eacute;rification et adaptation par l&rsquo;&eacute;quipe &eacute;ditoriale) ne sont
                    pas concern&eacute;s par cette suppression.
                </p>

                <h2>8. Partage de th&eacute;matiques &mdash; Codes de partage</h2>

                <h3>8.1 Description</h3>
                <p>
                    L&rsquo;utilisateur disposant d&rsquo;une th&eacute;matique personnalis&eacute;e peut
                    acqu&eacute;rir des <strong>codes de partage</strong> permettant &agrave; des tiers
                    d&rsquo;acc&eacute;der &agrave; cette th&eacute;matique en <strong>lecture seule</strong>
                    (consultation des quiz et r&eacute;sultats, sans possibilit&eacute; de modification).
                </p>

                <h3>8.2 Dur&eacute;e et activation</h3>
                <p>
                    Chaque code de partage donne acc&egrave;s pour une dur&eacute;e d&eacute;termin&eacute;e
                    (1&nbsp;mois, 6&nbsp;mois ou 12&nbsp;mois) &agrave; compter de son activation par le
                    destinataire. Un code non utilis&eacute; reste disponible sans limitation de dur&eacute;e.
                    Si le destinataire dispose d&eacute;j&agrave; d&rsquo;un acc&egrave;s actif, la nouvelle
                    dur&eacute;e est ajout&eacute;e &agrave; la p&eacute;riode en cours (prolongation).
                </p>

                <h3>8.3 Tarification</h3>
                <p>
                    Les codes de partage sont vendus par packs. Les tarifs sont affich&eacute;s avant
                    validation du paiement. Le paiement s&rsquo;effectue dans les m&ecirc;mes conditions
                    que les abonnements (article&nbsp;4). Des codes gratuits peuvent &ecirc;tre offerts
                    par l&rsquo;&eacute;diteur &agrave; titre promotionnel.
                </p>

                <h3>8.4 Restrictions</h3>
                <p>
                    Un code de partage est &agrave; usage unique. L&rsquo;utilisateur ne peut pas
                    activer ses propres codes. L&rsquo;acc&egrave;s partag&eacute; ne conf&egrave;re
                    aucun droit de modification, de copie ou de redistribution du contenu.
                </p>

                <h2>9. Codes cadeau</h2>

                <h3>9.1 Description</h3>
                <p>
                    Un <strong>code cadeau</strong> permet d&rsquo;offrir un abonnement &agrave; une
                    th&eacute;matique &eacute;ditoriale. Le code est g&eacute;n&eacute;r&eacute; apr&egrave;s
                    paiement et peut &ecirc;tre transmis au destinataire par email ou par tout autre moyen.
                </p>

                <h3>9.2 Activation</h3>
                <p>
                    Le destinataire doit disposer d&rsquo;un compte monquiz.fr pour activer son code cadeau.
                    L&rsquo;abonnement d&eacute;marre &agrave; la date d&rsquo;activation, pour la dur&eacute;e
                    associ&eacute;e au code (1&nbsp;mois, 6&nbsp;mois ou 12&nbsp;mois).
                </p>

                <h3>9.3 Conditions</h3>
                <p>
                    Les codes cadeau ne sont ni remboursables, ni &eacute;changeables apr&egrave;s g&eacute;n&eacute;ration.
                    Ils sont &agrave; usage unique. L&rsquo;&eacute;diteur peut &eacute;galement offrir des
                    codes cadeau &agrave; titre gracieux.
                </p>

                <h2>10. Publication de th&eacute;matiques</h2>

                <h3>10.1 Description</h3>
                <p>
                    L&rsquo;utilisateur peut soumettre sa th&eacute;matique personnalis&eacute;e &agrave; la
                    publication sur monquiz.fr. Si elle est approuv&eacute;e, la th&eacute;matique devient
                    accessible &agrave; l&rsquo;ensemble des utilisateurs de la plateforme.
                </p>

                <h3>10.2 Processus</h3>
                <p>
                    La soumission fait l&rsquo;objet d&rsquo;une <strong>v&eacute;rification &eacute;ditoriale</strong>
                    par l&rsquo;&eacute;quipe monquiz.fr. L&rsquo;&eacute;diteur peut accepter, demander des
                    modifications ou refuser la publication sans avoir &agrave; justifier sa d&eacute;cision.
                    Sont notamment refus&eacute;s les contenus portant atteinte aux droits de tiers, comportant
                    des erreurs factuelles excessives, ou de qualit&eacute; p&eacute;dagogique insuffisante.
                </p>

                <h3>10.3 Contrepartie</h3>
                <p>
                    En cas d&rsquo;approbation, l&rsquo;utilisateur peut recevoir une <strong>contrepartie
                    gracieuse</strong> d&eacute;termin&eacute;e par l&rsquo;&eacute;diteur (abonnement offert,
                    codes de partage, ou toute autre gratification). Cette contrepartie n&rsquo;est pas
                    contractuellement garantie et ne constitue pas une r&eacute;mun&eacute;ration.
                </p>

                <h3>10.4 Licence</h3>
                <p>
                    En soumettant une th&eacute;matique &agrave; la publication, l&rsquo;utilisateur accorde
                    &agrave; monquiz.fr une <strong>licence non exclusive, gratuite et cessible</strong> pour
                    utiliser, reproduire, adapter et distribuer les contenus sur la plateforme, pour la
                    dur&eacute;e des droits de propri&eacute;t&eacute; intellectuelle applicables. Cette
                    licence subsiste m&ecirc;me en cas de retrait ult&eacute;rieur de la th&eacute;matique.
                </p>

                <h3>10.5 Retrait</h3>
                <p>
                    L&rsquo;utilisateur peut demander le retrait de sa th&eacute;matique publi&eacute;e
                    &agrave; tout moment. Le retrait prend effet &agrave; l&rsquo;expiration des acc&egrave;s
                    en cours. monquiz.fr se r&eacute;serve &eacute;galement le droit de retirer une
                    th&eacute;matique pour tout motif l&eacute;gitime.
                </p>

                <h2>11. Responsabilit&eacute;</h2>
                <p>
                    Les contenus sont propos&eacute;s &agrave; titre p&eacute;dagogique. L&rsquo;&eacute;diteur
                    ne garantit pas le succ&egrave;s aux concours ou examens. L&rsquo;&eacute;diteur
                    s&rsquo;engage &agrave; maintenir le service accessible mais ne peut garantir une
                    disponibilit&eacute; ininterrompue.
                </p>

                <h2>12. R&eacute;siliation</h2>
                <p>
                    Les abonnements ne sont pas reconduits automatiquement. Aucune r&eacute;siliation
                    n&rsquo;est n&eacute;cessaire : l&rsquo;acc&egrave;s expire &agrave; la date de fin
                    de la p&eacute;riode souscrite.
                </p>

                <h2>13. Litiges</h2>
                <p>
                    En cas de litige, une solution amiable sera recherch&eacute;e en priorit&eacute;.
                    Le consommateur peut recourir gratuitement au service de m&eacute;diation FEVAD
                    (F&eacute;d&eacute;ration du e-commerce et de la vente &agrave; distance) &mdash;
                    60 rue La Bo&eacute;tie, 75008 Paris &mdash;{' '}
                    <a href="https://www.mediateurfevad.fr" target="_blank" rel="noopener noreferrer">
                        www.mediateurfevad.fr
                    </a>.
                </p>
                <p>
                    Plateforme de r&egrave;glement en ligne des litiges de la Commission europ&eacute;enne :{' '}
                    <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                        ec.europa.eu/consumers/odr
                    </a>.
                </p>

                <h2>14. Droit applicable</h2>
                <p>
                    Les pr&eacute;sentes CGV sont soumises au droit fran&ccedil;ais. Tout litige sera
                    port&eacute; devant les juridictions comp&eacute;tentes.
                </p>

                <div className="legal-footer">
                    <Link to="/">&larr; Retour &agrave; l&rsquo;accueil</Link>
                </div>
            </div>
        </div>
    );
}
